import React, { useEffect, useState } from 'react'
import ApplicationLogo from '../../components/ApplicationLogo'
import { Link, useLocation } from 'react-router-dom'
import UserBox from '../../features/user/UserBox'
import { useSelector } from 'react-redux'
import { RootState } from '../../app/store'
import { Button, IconButton } from '@mui/material'
import GenerateIcon from '../../components/GenerateIcon'

interface IMenuItem {
    title: string,
    link: string
}

const HeaderMenuItem: React.FC<IMenuItem> = (props) => {

    const location = useLocation()
    const { title, link } = props

    const pathname = location.pathname

    return (
        <Link to={link} className={pathname == link ? "header-menu-item active" : "header-menu-item"}>
            {title}
        </Link>
    )
}

export default function Header() {

    const { isAuthenticated } = useSelector((state: RootState) => state.auth)
    const [mobileHeaderClassName, setMobileHeaderClassName] = useState<string>("mobile-website-main-header-wrapper")
    const [showMobileHeader, setShowMobileHeader] = useState<boolean>(false)

    const menuItems: IMenuItem[] = [
        {
            title: "Home",
            link: "/"
        },
        {
            title: "My Requests",
            link: "/requests"
        },
        {
            title: "Warehouses",
            link: "/warehouses"
        },
        {
            title: "Inventory",
            link: "/items"
        },
    ]

    useEffect(() => {
        if (showMobileHeader){
            setMobileHeaderClassName("mobile-website-main-header-wrapper active")
        }else{
            setMobileHeaderClassName("mobile-website-main-header-wrapper")
        }
    }, [showMobileHeader])

    return(
        <>
            <div className={mobileHeaderClassName}>
                <div className="mobile-website-main-header">
                    <div className="content-of-mobile-website-main-header">

                        <div className="head-box-of-mobile-website-main-header">
                            <div className="content-of-head-box-of-mobile-website-main-header">

                                <Link to="/">
                                    <div className="logo-of-mobile-website-main-header">
                                        <ApplicationLogo isIcon />
                                    </div>
                                </Link>

                                <IconButton onClick={() => setShowMobileHeader(false)}>
                                    <GenerateIcon icon="close" />
                                </IconButton>

                            </div>
                        </div>

                        <div className="menu-of-mobile-website-main-header">
                            <div className="content-of-menu-of-mobile-website-main-header">
                                {menuItems.map((item, index) => <HeaderMenuItem {...item} key={index} />)}
                            </div>
                        </div>

                    </div>
                </div>
                <div className="mask-of-mobile-website-main-header" onClick={() => setShowMobileHeader(false)}></div>
            </div>

            <header className="website-main-header">
                <div className="content-of-website-main-header content-section-wrapper">
                    
                    {isAuthenticated && (
                        <div className="mobile-header-button-of-website-main-header">
                            <div className="content-of-mobile-header-button-of-website-main-header">
                                <IconButton onClick={() => setShowMobileHeader(true)}>
                                    <GenerateIcon icon="menu" />
                                </IconButton>
                            </div>
                        </div>
                    )}

                    <div className="logo-box-of-website-main-header">
                        <div className="content-of-logo-box-of-website-main-header">
                            <Link to="/">
                                <ApplicationLogo isIcon />
                            </Link>
                        </div>
                    </div>

                    {isAuthenticated && (
                        <div className="menu-of-website-main-header">
                            <div className="content-of-menu-of-website-main-header">
                                {menuItems.map((item, index) => <HeaderMenuItem {...item} key={index} />)}
                            </div>
                        </div>
                    )}

                    {isAuthenticated ? (
                        <div className="user-box-of-website-main-header">
                            <div className="content-of-user-box-of-website-main-header">
                                <UserBox />
                            </div>
                        </div>
                    ): (
                        <div className="website-header-not-logged-in-box">
                            <div className="content-of-website-header-not-logged-in-box">
                                <Link to="/sign-in">
                                    <Button className="general-button" color="error" variant="text">Sign-in</Button>
                                </Link>
                            </div>
                        </div>
                    )}

                </div>
            </header>
        </>
    )
}